import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface EntryCardRow {
  label: string;
  value: string;
}

export interface EntryCardChip {
  thumbnail: string;
  quantity: number;
}

@Component({
  selector: 'multi-shipment-entry-card-preview',
  templateUrl: './entry-card-preview.component.html',
  styleUrls: ['./entry-card-preview.component.scss'],
  standalone: false,
})
export class EntryCardPreviewComponent {
  @Input() number = 1;
  @Input() title = '';
  @Input() chips: EntryCardChip[] = [];
  @Input() rows: EntryCardRow[] = [];

  @Output() removePressed = new EventEmitter<void>();
}
